import React, { useRef, useState } from "react";
import { Link } from "react-router-dom";
// reactstrap components
import {
    Card,
    CardHeader,
    CardBody,
    Container,
    Row,
    Col,
    Button
} from "reactstrap";
// core components
import Header from "../../../../components/headers/Header";
import LoadingIndicator from "../../../../components/ui/LoadingIndicator";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
//import { Upload, Icon } from "antd";
import { Upload, Button as AntdBtn } from "antd";
import "antd/dist/antd.css";
import { useForm } from "react-hook-form";
import * as Helper from "../../../../utils/Helper"
import MessageBox from "../../../../components/ui/MessageBox";
import { UploadOutlined } from "@ant-design/icons";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { Actions, reducer, INITIAL_STATE, ActionTypes } from "../../../../redux/screens/admin/dictionary/word/EditRedux";
import AuthorizedScreen from "../../../../components/base/AuthorizedScreen";
import { NavigationService } from "../../../../navigation";
import UIDs from "../../../../UIDs";
import WordEditService from "../../../../services/screens/admin/dictionary/word/EditService";
import { GetPlainTextFromSentence } from "../../../../utils/MarkTextHelper";
import _ from "lodash";
import UnitService from "../../../../services/screens/admin/unit/forms/UnitService";
// import AppConfig from "../../../../config/AppConfig";
import AudioRecorder from "../../../../components/ui/AudioRecorder";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as FAIcons from "@fortawesome/free-solid-svg-icons";
import ImageField from "./ImageField";

const uid = UIDs.screens.admin.dictionary.word.edit;

class EditScreen extends AuthorizedScreen {

    get routeName() {
        return uid;
    }

    get reducer() {
        return reducer;
    }

    get actionHandlers() {
        return {
            [ActionTypes.LOAD_SCREEN_VIEW_ASYNC]: { done: null, error: this._handleAsyncActionError },
            [ActionTypes.SAVE_WORD_ASYNC]: {
                done: this._handleSaveWordAsyncDone,
                error: this._handleAsyncActionError
            }
        };
    }

    localVars = {
        navParams: {}
    };

    constructor(props) {
        super(props);

        this.localVars.navParams = NavigationService.getNavParams(props);
    }

    componentDidMount() {
        super.componentDidMount();

        const { id } = this.localVars.navParams;

        if (id)
            this.props.loadScreenViewAsync(id);
        else
            this.props.createWord();
    }

    render() {
        const { word } = this.props.localState;

        return (
            <>
                <Header />
                <Container className="mt--7" fluid>
                    <Row>
                        <div className="col">
                            {!word || this.isActionExecuting(ActionTypes.LOAD_SCREEN_VIEW_ASYNC) || this.isActionExecuting(ActionTypes.SAVE_WORD_ASYNC)
                                ? <LoadingIndicator />
                                : <EditForm
                                    {...this.props}
                                    navParams={this.localVars.navParams}
                                    word={word}
                                    onSave={this._handleSaveWord}
                                />
                            }
                        </div>
                    </Row>
                </Container>
            </>
        );
    }

    _handleSaveWord = (data) => {
        const { word } = this.props.localState;
        if (JSON.stringify(word.wordInfo, "", "\t") === JSON.stringify(data.wordInfo, "", "\t")) {
            data.wordInfo = null;
        }else if(data.initialId === data.id) {
            if(!data.wordInfo.chars) {
                this.displayError({ message: this.props.t("errKey", {key: "key chars"})});
                return false;
            }

            if(!data.wordInfo.syllables) {
                this.displayError({ message: this.props.t("errKey", {key: "key syllables"})});
                return false;
            }

            if(!data.wordInfo.codes) {
                this.displayError({ message: this.props.t("errKey", {key: "key codes"})});
                return false;
            }

            if(data.id !== data.wordInfo.chars.join("")) {
                this.displayError({ message: this.props.t("errContentChars", {content: "chars"})});
                return false;
            }

            if(data.pinyin !== data.wordInfo.syllables.join(" ")) {
                this.displayError({ message: this.props.t("errContentSyllables", {content: "syllables"})});
                return false;
            }
        }

        confirmAlert({
            title: this.props.t("confirmToSave"),
            message: this.props.t("sureToDo"),
            buttons: [
                {
                    label: this.props.t("yes"),
                    onClick: () => {
                        this.props.saveWordAsync(data);
                    }
                },
                {
                    label: this.props.t("no")
                }
            ]
        });
    }

    _handleSaveWordAsyncDone = () => {
        NavigationService.navigateToPageByUID(this, UIDs.screens.admin.dictionary.word.list, this.localVars.navParams);
    };

    _handleAsyncActionError = (action) => {
        this.displayError(action.error);
    };
}

function EditForm(props) {
    const formMethods = useForm();
    const { word } = props;
    let { id, pinyin, audioPath, wordInfo, level, images, attribute } = word;
    const { register, handleSubmit, errors, setValue, watch } = formMethods;
    const submitInputRef = useRef();

    const initialId = id;
    const initialPinyin = pinyin;

    // represent the generating button status
    const [state_generating, setstate_generating] = useState(false);
    // store the audio path
    const [state_audioPath, setstate_audioPath] = useState(audioPath);
    const [state_audioLoading, setstate_audioLoading] = useState(false);

    // 监视 form input
    const watchId = watch("id", id);
    const watchPinyin = watch("pinyin", pinyin);

    const UploadButton = ({ loading }) => (
        <Button color="success" onClick={(e) => e.preventDefault()} style={{ alignItems:"center" }}>
            {loading ? <FontAwesomeIcon icon={FAIcons.faSpinner} style={{ width: "17px", height: "17px" }} spin color={"#FFFFFF"} /> : <FontAwesomeIcon icon={FAIcons.faUpload} style={{ width: "17px", height: "17px" }} color={"#FFFFFF"} title={props.t("upload")} />}
            <span style={{margin:"0px 2px"}}/>
            {props.t("upload")}
        </Button>
    );

    const uploadAudioProps = {
        name: "fileData",
        showUploadList: false, // set to only upload one file
        customRequest: info => {
            startUpload(info.file, setstate_audioLoading, uploadAudioSuccessCallback);

            // props.uploadAudioAsync(info.file);
        },
        beforeUpload: file => {
            const isMp3 = Helper.isMp3(file.type);
            if (!isMp3) {
                MessageBox.danger({ text: props.t("uploadAudioFormatLimited"), duration: 5000 });
                return false;
            }
            const isLt2M = file.size / 1024 / 1024 < 2;
            if (!isLt2M) {
                MessageBox.danger({ text: props.t("uploadAudioSizeLimited", { fileSize: 2 }), duration: 5000 });
                return false;
            }
            return isMp3 && isLt2M;
        }
    };

    const startUpload = (file, setStateFunc, uploadSuccessCallback) => {
        setStateFunc(true);
        WordEditService.upload(
            file,
            response => {
                uploadSuccessCallback(response);
                setStateFunc(false);
            },
            error => {
                setStateFunc(false);
                MessageBox.danger({ text: error.message, duration: 5000 });
            }
        )
    };

    const clearAudio = () => {
        setstate_audioPath("");
    }

    const onSave = formData => {
        submitFormData(formData, formData.pinyin, state_audioPath, initialId);
    };

    const submitFormData = (formData, pinyin, audioPath, initialId) => {
        var letterInfo = formData.letterInfo;
        var imagesList = formData.images;
        var images = imagesList && imagesList.length > 0 ? imagesList.join(";") : null;

        try{
            letterInfo = letterInfo ? JSON.parse(formData.letterInfo) : letterInfo;
        }catch(e){
            MessageBox.danger({ text: props.t("wordInfo") + props.t("errJson") + " " + e.message, duration: 5000 });
            return false;
        }
        let submitData = {
            id: formData.id,
            pinyin: pinyin,
            audioPath: audioPath,
            initialId: initialId,
            wordInfo: letterInfo,
            level: formData.level,
            attribute: formData.attribute,
            images
        };

        props.onSave(submitData);
    }


    const startGenerate = () => {
        let wordArray = watchId;
        setstate_generating(true);
        //use plain text for generate syllables and audio
        let plainChars = GetPlainTextFromSentence(wordArray);

        UnitService.generate(
            plainChars,
            response => {
                setValue("pinyin", _.join(response.syllables, " "));
                setstate_audioPath(response.virtualPath);

                setstate_generating(false);
            },
            error => {
                setstate_generating(false);
                this.displayError(error);
            }
        );
    };

    const generateAudioWithSyllables = () => {
		let nowChars = watchId;
		let nowSyllables = watchPinyin;
		if (nowChars) {
			let plainChars = nowChars;

			let syllableArray = _.split(nowSyllables, " ");

			setstate_generating(true);
			UnitService.generateAudioWithSyllables(
				plainChars,
				syllableArray,
                props.voiceType,
				(response) => {
					//setValue(audioPathFieldName, response.virtualPath);
					setstate_audioPath(response.virtualPath);

					setstate_generating(false);
				},
				(error) => {
					setstate_generating(false);
					//this.displayError(error);
					MessageBox.danger({ text: error.message, duration: 5000 });
				}
			);
		}
	};

    const handleRecordEnd = (blob) => {
        let file = new File([blob], "recordFile.wav");
        WordEditService.upload(
            file,
            (response) => {
                uploadAudioSuccessCallback(response);
            },
            (error) => {
                //this.displayError(error);
                MessageBox.danger({ text: error.message, duration: 5000 });
            }
        );
    }

    const uploadAudioSuccessCallback = (data) => {
        const { virtualPath } = data;
        setstate_audioPath(virtualPath);
    };

    let audioElement = "";
    if (Helper.isNullOrEmpty(state_audioPath)) {
        audioElement = (
            <div className="row align-items-center" style={{ width: "60%", justifyContent: "space-around" }}>
                <div style={{ padding: 0 }}>
                    <div className="form-group">
                        <Button
                            disabled={state_generating}
                            color="primary"
                            onClick={() => {
                                generateAudioWithSyllables();
                            }}
                        >
                            {state_generating ? (
                                <FontAwesomeIcon icon={FAIcons.faSpinner} style={{ width: "17px", height: "17px" }} spin color={"#FFFFFF"} title={props.t("upload")} />
                            ) : (
                                <FontAwesomeIcon icon={FAIcons.faSignLanguage} style={{ width: "17px", height: "17px" }} color={"#FFFFFF"} title={props.t("upload")} />
                            )}
                            <span style={{ margin: "0px 2px" }} />
                            {state_generating ? props.t("generating") : props.t("generate")}
                        </Button>
                    </div>
                </div>
                <div>
                    <div className="form-group">{props.t("or")}</div>
                </div>
                <div style={{ padding: 0 }}>
                    <div className="form-group">
                        <Upload {...uploadAudioProps} >
                            <UploadButton loading={state_audioLoading} />
                        </Upload>
                    </div>
                </div>
                <div>
                    <div className="form-group">{props.t("or")}</div>
                </div>
                <div style={{ padding: 0 }}>
                    <div className="form-group">
                        <AudioRecorder
                            onRecordError={(error) => {
                                MessageBox.danger({ text: error.message, duration: 5000 });
                            }}
                            onRecordEnd={handleRecordEnd.bind(this)}
                        />
                    </div>
                </div>
            </div>
        );
    } else {
        audioElement = (
            <div className="row">
                <div className="col-lg-4">
                    <audio controls preload="none" controlsList="nodownload" src={Helper.convertToFileServerPath(state_audioPath)}>
                        <track kind="captions" />
                        Your browser does not support the audio element.
                    </audio>
                </div>
                <div className="col-lg-1">
                    <div className="form-group">
                        <button
                            type="button"
                            className="btn btn-default"
                            onClick={() => {
                                clearAudio();
                            }}
                        >
                            {props.t("delete")}
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    const fieldsForImages = {
        choices: { name: "images", value: images ? images.split(";") : null},
    };

    return (
        <Card className="shadow">
            <CardHeader className="bg-white border-0">
                <Row className="align-items-center">
                    <Col xs="8">
                        <h3 className="mb-0">{props.t("word")}</h3>
                    </Col>
                    <Col className="text-right" xs="4">
                        <Button
                            color="info"
                            onClick={() => submitInputRef.current.click()}
                            size="sm">
                            {props.t("save")}
                        </Button>&nbsp;
                        <Button
                            color="default"
                            tag={Link}
                            to={{ pathname: NavigationService.getPathNameByUID(UIDs.screens.admin.dictionary.word.list), state: props.navParams }}
                            size="sm">
                            {props.t("cancel")}
                        </Button>
                    </Col>
                </Row>
            </CardHeader>
            <CardBody>
                <form onSubmit={handleSubmit(onSave)}>
                    <div className="pl-lg-4">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="form-group">
                                    <label className="form-control-label">{props.t("word")}</label>
                                    <input name="id" type="text"
                                        className="form-control-alternative form-control" defaultValue={id}
                                        ref={register({ required: true })} />
                                    {errors.title && <span className="text-danger">{props.t("fieldIsRequired")}</span>}
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="form-group">
                                    <label className="form-control-label">{props.t("pinyin")}</label>
                                    <input name="pinyin" className="form-control-alternative form-control"
                                        defaultValue={pinyin}
                                        ref={register} />
                                </div>
                            </div>
                        </div>
                        {audioElement}
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="form-group">
                                    <label className="form-control-label">{props.t("level")}</label>
                                    <select name="level" ref={register} className="form-control-alternative form-control">
                                        <option value="" selected = {level ? true : false}>{props.t("level0")}</option>
                                        <option value="-1" selected = {level ? true : false}>{props.t("level-1")}</option>
                                        <option value={1} selected = {level === 1}>1</option>
                                        <option value={2} selected = {level === 2}>2</option>
                                        <option value={3} selected = {level === 3}>3</option>
                                        <option value={4} selected = {level === 4}>4</option>
                                        <option value={5} selected = {level === 5}>5</option>
                                        <option value={6} selected = {level === 6}>6</option>
                                        <option value={789} selected = {level === 789}>{props.t("level789")}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="form-group">
                                    <label className="form-control-label">{props.t("attribute")}</label>
                                    <select name="attribute" ref={register} className="form-control-alternative form-control">
                                        <option value="" selected = {attribute ? true : false}>{props.t("attribute0")}</option>
                                        <option value={"a"} selected = {attribute === "a"}>{props.t("attributea")}</option>
                                        <option value={"b"} selected = {attribute === "b"}>{props.t("attributeb")}</option>
                                        <option value={"c"} selected = {attribute === "c"}>{props.t("attributec")}</option>
                                        <option value={"d"} selected = {attribute === "d"}>{props.t("attributed")}</option>
                                        <option value={"e"} selected = {attribute === "e"}>{props.t("attributee")}</option>
                                        <option value={"f"} selected = {attribute === "f"}>{props.t("attributef")}</option>
                                        <option value={"g"} selected = {attribute === "g"}>{props.t("attributeg")}</option>
                                        <option value={"h"} selected = {attribute === "h"}>{props.t("attributeh")}</option>
                                        <option value={"i"} selected = {attribute === "i"}>{props.t("attributei")}</option>
                                        <option value={"j"} selected = {attribute === "j"}>{props.t("attributej")}</option>
                                        <option value={"k"} selected = {attribute === "k"}>{props.t("attributek")}</option>
                                        <option value={"l"} selected = {attribute === "l"}>{props.t("attributel")}</option>
                                        <option value={"m"} selected = {attribute === "m"}>{props.t("attributem")}</option>
                                        <option value={"n"} selected = {attribute === "n"}>{props.t("attributen")}</option>
                                        <option value={"o"} selected = {attribute === "o"}>{props.t("attributeo")}</option>
                                        <option value={"p"} selected = {attribute === "p"}>{props.t("attributep")}</option>
                                        <option value={"q"} selected = {attribute === "q"}>{props.t("attributeq")}</option>
                                        <option value={"r"} selected = {attribute === "r"}>{props.t("attributer")}</option>
                                        <option value={"s"} selected = {attribute === "s"}>{props.t("attributes")}</option>
                                        <option value={"t"} selected = {attribute === "t"}>{props.t("attributet")}</option>
                                        <option value={"u"} selected = {attribute === "u"}>{props.t("attributeu")}</option>
                                        <option value={"v"} selected = {attribute === "v"}>{props.t("attributev")}</option>
                                        <option value={"w"} selected = {attribute === "w"}>{props.t("attributew")}</option>
                                        <option value={"x"} selected = {attribute === "x"}>{props.t("attributex")}</option>
                                        <option value={"y"} selected = {attribute === "y"}>{props.t("attributey")}</option>
                                        <option value={"z"} selected = {attribute === "z"}>{props.t("attributez")}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <ImageField formMethods={formMethods} fields={fieldsForImages} choiceNum="3" />
                        {id && <div className="row" style={{marginTop:10}}>
                            <div className="col-lg-12">
                                <div className="form-group">
                                    <label className="form-control-label">{props.t("wordInfo")}</label>
                                    <textarea disabled={!id} name="letterInfo" rows="15"
                                        className="form-control-alternative form-control"
                                        defaultValue={JSON.stringify(wordInfo, "", "\t")}
                                        ref={register} />
                                </div>
                            </div>
                        </div>}
                    </div>
                    <input ref={submitInputRef} type="submit" hidden />
                </form>
            </CardBody>
        </Card >
    );
}

const mapStateToProps = state => {
    return {
        localState: state.screens[reducer.key] ? state.screens[reducer.key] : INITIAL_STATE,
        userId: state.session.userId
    };
};

const mapDispatchToProps = dispatch => {
    return {
        loadScreenViewAsync: word => dispatch(Actions.loadScreenViewAsync(word)),
        saveWordAsync: vo => dispatch(Actions.saveWordAsync(vo)),
        createWord: () => dispatch(Actions.createWord())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation(uid)(EditScreen));
